import { jsx } from '@emotion/react/jsx-runtime';
import { createComponentWithRef, useSlot } from '@nettbureau/core';
import { useCss } from '@nettbureau/styling';
import { useSeparator } from 'react-aria';

/**
 * Dividers separate content into clear groups.
 */ const Divider = createComponentWithRef((props, ref)=>{
    const [mergedProps, mergedRef] = useSlot('Divider', props, ref);
    const { className, css, direction = 'horizontal', width = 'regular' } = mergedProps;
    const { separatorProps } = useSeparator({
        orientation: direction
    });
    const dividerCss = useCss(({ theme })=>[
            {
                background: theme.aliases.strokeColors.gray.weak,
                border: 0,
                flexShrink: 0,
                margin: 0
            },
            direction === 'vertical' ? {
                width: theme.strokeWidths[width]
            } : {
                height: theme.strokeWidths[width],
                width: '100%'
            },
            css
        ]);
    return /*#__PURE__*/ jsx("hr", {
        "data-divider": true,
        ...separatorProps,
        ref: mergedRef,
        className: className,
        css: dividerCss
    });
});

export { Divider };
//# sourceMappingURL=divider.js.map
